module.exports = __webpack_public_path__ + "static/media/XXe.e8e4efef.png";